import $ from 'jquery';

const defaults = {
  first: 'all',
  last: 'other',
};

function AlphaTabs(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.init();
}

AlphaTabs.prototype = {
  init() {
    const classArr = [];
    this.$element.find('.tab').each((i, element) => {
      const tempId = $(element).find('span').text().split(' (');
      const newId = tempId[0].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase();
      $(element).addClass(newId);
      classArr.push(newId);
    });
    classArr.sort();
    if (this.settings.first) {
      const firstIndex = classArr.indexOf(this.settings.first);
      if (firstIndex > -1) { classArr.splice(firstIndex, 1); }
      classArr.unshift(this.settings.first);
    }
    if (this.settings.last) {
      const lastIndex = classArr.indexOf(this.settings.last);
      if (lastIndex > -1) { classArr.splice(lastIndex, 1); }
      classArr.push(this.settings.last);
    }
    classArr.forEach((elem) => {
      this.$element.find('.tab.other').remove(); // Ticket #14610
      this.$element.find(`.tab.${elem}`).appendTo(this.$element);
    });
  },
};

export default AlphaTabs;
